import { render, staticRenderFns } from "./novatabelapreco.vue?vue&type=template&id=f779b502&"
import script from "./novatabelapreco.vue?vue&type=script&lang=js&"
export * from "./novatabelapreco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports